<script lang="ts">
	// UI
	import {
		HubProfileBottomLineButton,
		PhotoIcon,
		Popper,
		RotateIcon,
	} from "@hitit/new_ui/src";
	import DownloadImage from "@hitit/hub/src/assets/Icons/DownloadIcon.png";
	import DragAndDrop from "@hitit/hub/src/components/DragAndDrop.svelte";
	import ComponentLoading from "@hitit/hub/src/v7/components/common/ComponentLoading.svelte";
	// Utils
	import { api, t } from "@hitit/hub/src/stores";
	import { OBJECT_PURPOSE_STORE_REGISTRATION, putS3File } from "@hitit/api";
	import { rotateImage } from "@hitit/utils";
	import axios from "axios";

	//Props
	export let imageaddr = "";
	export let editmode = false;

	//Constants
	//Variables
	let loading = false;
	let mouseenter = false;
	let imageUrl: string = "";
	$: registrationStyle = imageUrl ? `background-image : url(${imageUrl})` : "";
	//Functions
	function changeImage(file: File | Blob | null) {
		if (!file) {
			imageUrl = "";
			return;
		}
		if (imageUrl) URL.revokeObjectURL(imageUrl);
		imageUrl = URL.createObjectURL(file);
	}
	async function uploadImage(e: { detail: File }) {
		//
		try {
			loading = true;
			const fileUploadResponse = await $api.getFileUploadUrl({
				fileName: "registration",
				fileType: "PNG",
				objectPurpose: OBJECT_PURPOSE_STORE_REGISTRATION,
			});

			await putS3File(fileUploadResponse.data.url, e.detail);
			imageaddr = fileUploadResponse.data.id;

			changeImage(e.detail);
			loading = false;
		} catch (error) {
			console.log(error);
		}
	}

	function deleteAll() {
		imageaddr = "";
		imageUrl = "";
	}

	async function loadImage(addr: string) {
		try {
			loading = true;
			const storeImageString = addr;
			if (storeImageString === "") return;
			if (typeof storeImageString !== "string") return;
			const imageKey = storeImageString.split("|")[2];

			if (imageKey) {
				const imageResponse = await $api.getFileAccessUrl(imageKey);
				const imageDataResponse = await axios.get(imageResponse.data.url, {
					responseType: "blob",
				});

				changeImage(imageDataResponse.data);
			}
		} catch (error) {
			console.log(error);
		} finally {
			loading = false;
		}
	}

	async function _rotateImage(degree: number, imageURL: string) {
		try {
			const rotatedImage = await rotateImage(imageURL, degree);
			if (rotatedImage) {
				const file = new File([rotatedImage], "registration");
				await uploadImage({ detail: file });
			} else {
				changeImage(rotatedImage);
			}
		} catch (error) {
			console.log(error);
		}
	}

	async function imageFileView() {
		try {
			if (imageUrl === "" || editmode) return;

			const reader = new FileReader();
			const imgData = await fetch(imageUrl);
			const blobData = await imgData.blob();
			reader.readAsDataURL(blobData);
			reader.onloadend = () => {
				const base64 = reader.result;

				if (typeof base64 === "string") {
					const newTab = window.open("", "FullSizeImage");
					newTab?.document.write(`<img src='${base64}' style="width : 100%"/>`);
				}
			};
		} catch (error) {
			console.log(error);
		}
	}
	//Do
	$: loadImage(imageaddr);
</script>

<div class="container">
	<div class="registration" style={registrationStyle} on:click={imageFileView}>
		{#if editmode}
			<div
				class="drop-cover"
				on:dragover={() => {
					mouseenter = true;
				}}
				on:dragleave={() => {
					mouseenter = false;
				}}
				on:mouseleave={() => {
					mouseenter = false;
				}}
				on:mouseenter={() => {
					mouseenter = true;
				}}
			>
				{#if loading}
					<ComponentLoading />
				{:else}
					<DragAndDrop on:file-update={uploadImage}>
						<div class="photoicon">
							<PhotoIcon active={mouseenter} />
						</div>
					</DragAndDrop>
				{/if}
			</div>
		{/if}
	</div>
	<div class="controller" class:editmode={editmode}>
		{#if editmode}
			<div class="rotate-icons">
				<span class="rotate right" on:click={() => _rotateImage(90, imageUrl)}>
					<RotateIcon right />
				</span>
				<span class="rotate left" on:click={() => _rotateImage(270, imageUrl)}>
					<RotateIcon />
				</span>
			</div>
			<img
				id="delete"
				src="/img/icons/deleteIcon.png"
				alt="delete"
				on:click={deleteAll}
			/>
		{:else}
			<div class="downloader">
				<div class="popper">
					<Popper
						fill={"#3c68d6"}
						description={$t("hub.store.ko_registration.tooltip")}
					/>
				</div>
				<HubProfileBottomLineButton rightIconVisible={false}>
					<div class="download-container">
						<a download={"registration.png"} href={imageUrl}>
							사업자 등록증 이미지 다운로드
						</a>
						<img src={DownloadImage} alt="Download revenue" />
					</div>
				</HubProfileBottomLineButton>
			</div>
		{/if}
	</div>
</div>

<style lang="scss">
	@import "../../../../variables.scss";
	.container {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 10px;

		.registration {
			background-size: contain;
			background-repeat: no-repeat;
			background-position: center center;
			width: 300px;
			height: 300px;
			position: relative;
			background-color: #e6e7ed;
			.drop-cover {
				background-color: rgba($color: #46474b, $alpha: 0.8);
				width: 100%;
				height: 100%;

				&:hover {
					cursor: pointer;
				}
				.photoicon {
					position: absolute;
					top: 50%;
					left: 50%;
					transform: translate(-50%, -50%);
					width: 60.5px;
					height: 61px;
				}
			}
		}
		.controller {
			display: flex;
			flex-direction: row;
			width: 300px;
			justify-content: space-between;

			&.editmode {
				justify-content: space-between;
				gap: 20px;
				.rotate-icons {
					display: flex;
					gap: 20px;
					.rotate {
						width: 30.2px;
						height: 30.5px;
						&:hover {
							cursor: pointer;
						}
					}
				}
			}

			.downloader {
				display: flex;
				gap: 10px;
				height: 24px;

				.popper {
					width: 24px;
					height: 24px;
					font-size: 0.875rem;
					color: #46474b;
				}

				.download-container {
					display: flex;
					gap: 10px;
					align-items: center;
					font-weight: 500;
					color: #3c68d6;
				}

				a {
					&:visited {
						color: #3c68d6;
					}
				}

				img {
					width: 13.9px;
					height: 15.6px;
					object-fit: contain;
				}
			}
			#delete {
				width: 26px;
				height: 26.2px;
				&:hover {
					cursor: pointer;
				}
			}
		}
	}

	@include DesktopSize {
		.container {
			flex-direction: row;
			gap: 20px;

			.controller {
				flex-direction: column;
				height: 300px;
				&.editmode {
					.rotate-icons {
						.rotate {
							width: 41.2px;
							height: 41.8px;
						}
					}
				}

				#delete {
					width: 36px;
					height: 36.2px;
					object-fit: contain;
				}
				.downloader {
					.popper {
						font-size: 1rem;
					}
					a {
						font-size: 1.25rem;
						letter-spacing: -0.8px;
					}
					img {
						width: 16px;
						height: 18px;
					}
				}
			}
		}
	}
</style>
